// Theme: phoenix-ember
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'phoenix-ember',
  name: 'PHOENIX EMBER',
  tagline: 'PHOENIX EMBER',
  description: 'Estrutura Phoenix com paleta ember de brasa quente.',
  category: 'fantasy-realms',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#1C0B08', '#2A1410', '#DC2626', '#FFD9C4'],
  familyId: 'phoenix',
  variantName: 'EMBER',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-sans theme-phoenix-ember'
  },
  colorVars: {
    '--accent': '#DC2626',
    '--accent-foreground': '#1C0B08',
    '--background': '#1C0B08',
    '--border': '#8A3A20',
    '--card': '#2A1410',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFD9C4',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1C0B08',
    '--foreground': '#FFD9C4',
    '--hold-fill': '#DC2626',
    '--input': '#8A3A20',
    '--modal-bg': '#1C0B08',
    '--modal-border': '#8A3A20',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A3A20',
    '--muted-foreground': '#FFD9C4',
    '--nav-active': '#DC2626',
    '--nav-bg': '#2A1410',
    '--popover': '#2A1410',
    '--popover-foreground': '#FFD9C4',
    '--primary': '#DC2626',
    '--primary-foreground': '#1C0B08',
    '--ring': '#DC2626',
    '--secondary': '#8A3A20',
    '--secondary-foreground': '#FFD9C4',
    '--streak': '#DC2626',
    '--success': '#22c55e',
    '--success-foreground': '#1C0B08',
    '--xp': '#DC2626',
    '--xp-bg': '#2A1410'
  },
  resolvedVars: {
    '--accent': '#DC2626',
    '--accent-foreground': '#1C0B08',
    '--accent-foreground-hsl': '9 56% 7%',
    '--accent-foreground-oklch': 'from #1C0B08 l c h',
    '--accent-hsl': '0 72% 51%',
    '--accent-oklch': 'from #DC2626 l c h',
    '--background': '#1C0B08',
    '--background-hsl': '9 56% 7%',
    '--background-oklch': 'from #1C0B08 l c h',
    '--border': '#8A3A20',
    '--border-hsl': '15 62% 33%',
    '--border-oklch': 'from #8A3A20 l c h',
    '--border-w': '1px',
    '--card': '#2A1410',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FFD9C4',
    '--card-foreground-hsl': '21 100% 88%',
    '--card-foreground-oklch': 'from #FFD9C4 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '9 45% 11%',
    '--card-oklch': 'from #2A1410 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1C0B08',
    '--destructive-foreground-hsl': '9 56% 7%',
    '--destructive-foreground-oklch': 'from #1C0B08 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFD9C4',
    '--foreground-hsl': '21 100% 88%',
    '--foreground-oklch': 'from #FFD9C4 l c h',
    '--hold-fill': '#DC2626',
    '--hold-fill-hsl': '0 72% 51%',
    '--hold-fill-oklch': 'from #DC2626 l c h',
    '--input': '#8A3A20',
    '--input-hsl': '15 62% 33%',
    '--input-oklch': 'from #8A3A20 l c h',
    '--modal-bg': '#1C0B08',
    '--modal-bg-hsl': '9 56% 7%',
    '--modal-bg-oklch': 'from #1C0B08 l c h',
    '--modal-border': '#8A3A20',
    '--modal-border-hsl': '15 62% 33%',
    '--modal-border-oklch': 'from #8A3A20 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A3A20',
    '--muted-foreground': '#FFD9C4',
    '--muted-foreground-hsl': '21 100% 88%',
    '--muted-foreground-oklch': 'from #FFD9C4 l c h',
    '--muted-hsl': '15 62% 33%',
    '--muted-oklch': 'from #8A3A20 l c h',
    '--nav-active': '#DC2626',
    '--nav-active-hsl': '0 72% 51%',
    '--nav-active-oklch': 'from #DC2626 l c h',
    '--nav-bg': '#2A1410',
    '--nav-bg-hsl': '9 45% 11%',
    '--nav-bg-oklch': 'from #2A1410 l c h',
    '--popover': '#2A1410',
    '--popover-foreground': '#FFD9C4',
    '--popover-foreground-hsl': '21 100% 88%',
    '--popover-foreground-oklch': 'from #FFD9C4 l c h',
    '--popover-hsl': '9 45% 11%',
    '--popover-oklch': 'from #2A1410 l c h',
    '--primary': '#DC2626',
    '--primary-foreground': '#1C0B08',
    '--primary-foreground-hsl': '9 56% 7%',
    '--primary-foreground-oklch': 'from #1C0B08 l c h',
    '--primary-hsl': '0 72% 51%',
    '--primary-oklch': 'from #DC2626 l c h',
    '--radius': '12px',
    '--ring': '#DC2626',
    '--ring-hsl': '0 72% 51%',
    '--ring-oklch': 'from #DC2626 l c h',
    '--secondary': '#8A3A20',
    '--secondary-foreground': '#FFD9C4',
    '--secondary-foreground-hsl': '21 100% 88%',
    '--secondary-foreground-oklch': 'from #FFD9C4 l c h',
    '--secondary-hsl': '15 62% 33%',
    '--secondary-oklch': 'from #8A3A20 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#DC2626',
    '--streak-hsl': '0 72% 51%',
    '--streak-oklch': 'from #DC2626 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1C0B08',
    '--success-foreground-hsl': '9 56% 7%',
    '--success-foreground-oklch': 'from #1C0B08 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(0 72% 51% / 0.15)',
    '--xp': '#DC2626',
    '--xp-bg': '#2A1410',
    '--xp-bg-hsl': '9 45% 11%',
    '--xp-bg-oklch': 'from #2A1410 l c h',
    '--xp-hsl': '0 72% 51%',
    '--xp-oklch': 'from #DC2626 l c h'
  }
}
